// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zGvH","label":"styles_label__1bxsB"};